<template>
    <div class="crumbs template4" :class="{'is-empty': isShowEmpty, 'show-map': showMap}" v-if="breadCrumbs.length > 0">
        <div class="content">
            <div class="left">
                <a
                    v-for="(crumb, index) in breadCrumbs"
                    :key="crumb.key + crumb.keywordType"
                    class="crumb_item"
                    :class="{
                        'is-link':
                            crumb.keywordType !== 'state' &&
                            index !== breadCrumbs.length - 1
                    }"
                    rel="noopener norefferrer"
                    :href="
                        crumb.keywordType === 'state' ||
                            index === breadCrumbs.length - 1
                            ? 'javascript:void(0);'
                            : getUrl(crumb, index)
                    "
                >
                    <span
                        class="crumb_inner"
                        :class="{
                            'is-link':
                                crumb.keywordType !== 'state' &&
                                index !== breadCrumbs.length - 1
                        }"
                    >{{ crumb.name }}</span>
                    <span class="crumb_separator">></span>
                </a>
            </div>
            <a
                class="right"
                @click="insight"
                v-if="showInsightGo"
                rel="noopener noreferrer"
            >
                <span class="market_insight">{{
                    $t('md-search-result.marketInsights')
                }}</span>
                <span class="go iconfont icon-arrow"></span>
            </a>
        </div>
    </div>
</template>

<script>
import core from '../../crumbs';
export default {
    mixins: [core]
};
</script>

<style lang="scss">
@import '../../../../theme/media.scss';
.crumbs.template4 {
    @include media-min-800 {
        padding-top: 25px;
        padding-bottom: 20px;
    }
    @include media-800 {
        padding: 15px 15px 0 15px;
    }
    .content {
        background-color: #f5f6fa;
        /* padding: 15px 20px; */
        padding: 12px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        @include media-600 {
            padding: 12px 15px;
            background-color: #f5f6fa;
        }
        .left {
            flex: 1;
            display: flex;
            flex-wrap: wrap;

            .crumb_item {
                color: #797e8b;
                font-size: 14px;
                @include media-600 {
                    font-size: 12px;
                }
                cursor: default;
                &.is-link {
                    cursor: pointer;
                }
                &:last-child {
                    .crumb_separator {
                        display: none;
                    }
                }
                .crumb_inner {
                    line-height: 1.67;
                    letter-spacing: normal;
                    &.is-link {
                        text-decoration: underline;
                    }
                }
                .crumb_separator {
                    margin: 0 5px;
                }
            }
        }
        .right {
            margin-left: 15px;
            flex-grow: 0;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            cursor: pointer;
            font-size: 16px;
            color: #202437;
            @include media-800 {
                font-size: 14px;
            }
            .market_insight {
                margin-right: 10px;
            }
        }
    }
    &.is-empty {
        padding-bottom: 20px;
        .content {
            background-color: transparent !important;
            padding: 0;
            .left {
                display: inline-block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                word-break: break-all;
            }
        }
        .crumb_inner {
            color: var(--g-btn-background);
        }
        .crumb_separator { 
            color: #a8a8a8;
        }
        .right {
            line-height: 16px;
            .market_insight { 
                margin-right: 8px;
                color: #505050;
                font-size: 14px;
            }
            .go.iconfont {
                color: #505050;
            }
            &:hover {
                .market_insight {
                    color: var(--g-btn-background);
                }
                .go.iconfont { 
                    color: var(--g-btn-background);
                }
            }
        }
        &.show-map {
            .right {
                .market_insight { 
                    color: rgba(139, 147, 167, 1);
                    font-size: 14px;
                }
                .go.iconfont {
                    color:rgba(139, 147, 167, 1);
                }
                &:hover {
                    .market_insight {
                        color: var(--g-btn-background);
                    }
                    .go.iconfont { 
                        color: var(--g-btn-background);
                    }
                }
            }
        }
    }
}
</style>
